"use client"

import { ToastContainer, Bounce } from "react-toastify"
import "react-toastify/dist/ReactToastify.css"

const Toaster = () => {
  return (
    <>
      <style jsx global>{`
        .Toastify__progress-bar {
          background: hsl(var(--kinetic-magenta)) !important;
        }
        .Toastify__progress-bar--success {
          background: hsl(var(--kinetic-magenta)) !important;
        }
        .Toastify__progress-bar--error {
          background: #ef4444 !important;
        }
        .Toastify__progress-bar--info {
          background: #3b82f6 !important;
        }
        .Toastify__progress-bar--warning {
          background: #f59e0b !important;
        }
        /* Keep all toast backgrounds white */
        .Toastify__toast--error,
        .Toastify__toast--warning,
        .Toastify__toast--info,
        .Toastify__toast--success {
          background: #fff !important;
          color: #374151 !important;
        }
      `}</style>
      <ToastContainer
        position="bottom-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
        transition={Bounce}
        icon={false}
        closeButton={false}
      />
    </>
  )
}

export { Toaster }
